import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'volgende-bijeenkomst',
    templateUrl: 'volgende-bijeenkomst.html'
})
export class VolgendeBijeenkomst implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/volgende-bijeenkomst/volgende-bijeenkomst.ts